import GenericFormTable from './generic-form-table';

export default GenericFormTable;